// App global
export const globalAppName: string = 'SkillControl';
export const globalAppVersion: string = '0.9.12'; //this is the main version: increase on every release
export const globalToastDelay: number = 4000;
export const globalTrialLengthDays: number = 30;
export const globalNavBarHeight: number = 48;
//Row height of one entry in the main menu. The single place to change it: the nav styles in
//components/NavMain/navMainStylesV9.ts derive every row height from this value.
export const globalNavRowHeight: number = 40;

// Languages
// These must also be included in the supportedLngs of services/Localization/i18n.ts
export const supportedUILanguages: Map<string, string> = new Map<string, string>();
supportedUILanguages.set('en', 'English');
supportedUILanguages.set('nl', 'Nederlands');
supportedUILanguages.set('de', 'Deutsch');

// Internal URL's
export const globalNotFoundURL: string = '/not-found';
export const globalNotAuthorizedURL: string = '/not-authorized';
//the pages a Microsoft redirect sign-in may land back on; any other page lands on the root
export const globalReturnUrls: string[] = ['/'];

// Lists and search (the ux-guidelines skill, sections 3 and 6)
//the page of an admin grid with the range and Previous/Next pager
export const globalPageSize: number = 50;
//the page a Load more button adds to a card list
export const globalLoadMoreSize: number = 50;
//the page of a run history (a schedule's runs): smaller, each run is a card with its documents
export const globalRunHistoryPageSize: number = 20;
//the pause after the last key stroke before a server-backed search is sent
export const globalSearchDelayMs: number = 300;

// The directory user search of Add user (GET users/directory, phase 52, ISOPlanner's values): from this many
// characters, and at most this many results
export const globalDirectorySearchMinChars: number = 2;

export const globalDirectorySearchMaxResults: number = 50;

//Screen Resolution
export const globalDesktopSize: number = 1024;
export const globalDesktopHeight: number = 768;
